class BuildTags {
}
/** Hash the last time inertia was built */
BuildTags.buildHash = '56bcc74e';
/** Version of the package.json file the last time inertia was built */
BuildTags.packageVersion = '1205.0.4';
/** Time inertia was built in UTC */
BuildTags.buildTime = 'Tue, 27 Oct 2026 19:06:00 GMT';
/** Time inertia was built in Boston time */
BuildTags.buildTimeBoston = '2026-10-27 15:05:45 Boston';
/** Detailed build tags string */
BuildTags.detailed = 'BuildTags: 2026-10-27 15:05:45 Boston - 56bcc74e - 1205.0.4';
export default BuildTags;
